<banner-app [Fixtop]="'fixed-top'" [retroSelected]="false" [infoDueno]="true"  [showPromo]="true"></banner-app>

<div class="root">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="content-wrapper d-flex flex-column align-items-center text-center mt-5 pt-0 pt-md-5 pb-5">
          <div class="row order-2 order-md-1 mt-0 mt-md-5">
            <h2 class="feedback-title mb-5 mb-lg-3">
              En este momento tu ubicación está fuera de nuestra zona de cobertura actual. Seguimos trabajando para ofrecerte más opciones.
            </h2>
          </div>

          <img
            class="row order-1 order-md-2 feedback-image"
            src="./assets/img/motoHome.gif"
            width="300"
            height="192"
            priority
            alt="Ilustración de una persona sentada en un reloj de arena, representando una pausa."
          />

          <div class="container tamanioBoton order-3">
            <button class="btn btn-primary w-100 py-2 botonContinuar" (click)="volverInicio()">Volver al inicio</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer-app class="footer-fixed" />
